import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";
import { useRoute } from "vue-router";
import MainLayout from "@/layouts/MainLayout.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props, { expose: __expose }) {
  __expose();

const route = useRoute();

const layout = computed(() => route.meta.layout || MainLayout);
let currentVersion = "";
const checkAppVersion = async () => {
  try {
    const res = await fetch("/version.json", { cache: "no-cache" });
    const data = await res.json();
    if (!currentVersion) {
      currentVersion = data.version;
      return;
    }
    if (data.version !== currentVersion) {
      location.reload();
    }
  } catch (err) {
    console.warn(err);
  }
};
if (process.env.NODE_ENV === "production") {
  setInterval(checkAppVersion, 60000);
}

const __returned__ = { route, layout, get currentVersion() { return currentVersion }, set currentVersion(v) { currentVersion = v }, checkAppVersion, computed, get useRoute() { return useRoute }, MainLayout }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})